import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "../hooks/useLangPath";
import "./Footer.css";

function Footer() {
  const { t } = useTranslation();
  const langPath = useLangPath();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <p className="footer-disclaimer">{t("footer.disclaimer")}</p>
      <p className="footer-bottom">
        <span>&copy; 2024 - {currentYear} {t("footer.rights")}</span>
        <span className="footer-sep">|</span>
        <Link to={langPath("/terms-of-use")} className="footer-link">
          {t("footer.termsOfUse")}
        </Link>
      </p>
    </footer>
  );
}

export default Footer;
